import { LoginService } from '../security/login.service';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { PUBLIC_LOGIN_PATH } from 'src/app/constants/NextGenConstants';

export const authorizationGuard = () => {
  const loginService = inject(LoginService);
  const router = inject(Router);

  if (loginService.isUserAuthorized()) {
    return true;
  }

  router.navigate([PUBLIC_LOGIN_PATH]);
  return false;
};
